<template>
    <div class="ls-single-step-signup">
        <div class="ls-super-grid grid grid--justify-center">
            <div v-if="loading.quotingOrder" class="grid__col-md-8 ls-single-step-signup__col-main">
                <ls-loading-bar-v1 v-if="loading.loadingType === 'progressBar'"></ls-loading-bar-v1>
                <ls-loading v-else></ls-loading>
            </div>
            <div v-else class="grid__col-md-8 ls-single-step-signup__col-main">
                <router-view></router-view>
            </div>

            <div
                v-if="!loading.quotingOrder && desktop"
                class="grid__col-md-4 ls-single-step-signup__col-sidebar"
            >
                <ls-affix :offset="72" :min-height-disabled="affixMinHeightDisabled">
                    <div class="ls-single-step-signup__sidebar">
                        <div class="address-sidebar__container">
                            <ls-address-sidebar></ls-address-sidebar>
                        </div>
                        <transition name="ls-fade" mode="out-in">
                            <div
                                v-if="$route.meta.showOrderSummary"
                                class="order-summary__container"
                            >
                                <ls-order-summary></ls-order-summary>
                            </div>
                        </transition>
                    </div>
                    <div
                        v-if="$route.meta.showOrderSummary && !isStandAloneTreatment"
                        class="order-summary__mowing-description ls-align--center"
                        data-font-size="-2"
                        test-id="mowing-services-panel"
                    >
                        <span class="ls-uppercase ls-bold">Mowing Subscription Includes</span>
                        <br />
                        <span
                            >Lawn mowing, edging, and blowing clippings off of hard surfaces.</span
                        >
                    </div>
                    <div
                        v-if="renderFAQ"
                        class="ls-faq-list__container ls-margin--top"
                        test-id="faq"
                    >
                        <h2 class="ls-faq-list__h2">Questions?</h2>
                        <lsFaqListTreatment v-if="isStandAloneTreatment" />
                        <lsFaqList v-else />
                    </div>
                </ls-affix>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { SCREEN_SIZE__GET_DESKTOP_SCREEN } from '@/store/types';
import lsLoading from '@/components/original-mydot/loading/Loading.vue';
import lsLoadingBarV1 from '@/components/original-mydot/loading-bar-v1/LoadingBarV1.vue';
import lsAddressSidebar from '@/components/original-mydot/address-sidebar/AddressSidebar.vue';
import lsOrderSummary from '@/components/original-mydot/order-summary/OrderSummary.vue';
import lsAffix from '@/components/general/affix/Affix.vue';
import lsFaqList from '@/components/general/faqList/FaqList.vue';
import lsFaqListTreatment from '@/components/general/faqListTreatment/FaqListTreatment.vue';
import { serviceType } from '@/constants';

export default {
    name: 'SingleStepSignup',
    components: {
        lsLoading,
        lsLoadingBarV1,
        lsAddressSidebar,
        lsOrderSummary,
        lsAffix,
        lsFaqList,
        lsFaqListTreatment,
    },
    computed: {
        ...mapState(['loading', 'order']),
        ...mapGetters({
            desktop: SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        renderFAQ() {
            return (
                this.order.show_faq &&
                this.$route.meta.showFAQ !== false &&
                process.env.VUE_APP_BRAND !== 'lawnlove'
            );
        },
        affixMinHeightDisabled() {
            // conditionally removes the affix min height
            return this.renderFAQ ? 9000 : 600;
        },
        isStandAloneTreatment() {
            return serviceType.TREATMENT === this.order.intent;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-single-step-signup__col-main {
    max-width: 700px;
}

.ls-single-step-signup__col-sidebar {
    max-width: 350px;
}

.address-sidebar__container {
    background-color: palette(white);
}

.order-summary__container {
    padding: rem(-1);
    background-color: palette(white);
}

.ls-single-step-signup__sidebar {
    border: 1px solid palette(gray, x-light);
}

.order-summary__mowing-description {
    padding: rem(0) rem(-1);
    margin-top: rem(0);
    background-color: palette(white);
    color: palette(gray, mid);
    line-height: 1.5;
}
.ls-faq-list__container {
    background-color: palette(white);
    padding: 15px;
    border: 1px solid palette(gray, x-light);
}

.ls-faq-list__h2 {
    text-align: center;
    margin-bottom: 10px;
}

.themed-app {
    .address-sidebar__container {
        background-color: $theme-color-white;
    }

    .order-summary__container {
        background-color: $theme-color-white;
    }

    .ls-single-step-signup__sidebar {
        border-color: $theme-color-gray;
    }

    .order-summary__mowing-description {
        background-color: $theme-color-white;
        color: $theme-color-gray-dark;
    }
    .ls-faq-list__container {
        background-color: $theme-color-white;
        border-color: $theme-color-gray;
    }
}

.themed-lawnlove {
    .ls-single-step-signup__sidebar,
    .address-sidebar__container,
    .order-summary__mowing-description,
    .ls-faq-list__container,
    .ls-mowing-services__description {
        border-radius: 15px;
    }

    .order-summary__container {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }

    .ls-single-step-signup__sidebar {
        .address-sidebar__container:last-child {
            overflow: hidden;
        }
    }

    .ls-faq-list__container {
        margin: 1rem 0;
    }
}

.themed-lawnlove {
    .order-summary__mowing-description {
        border: 1px solid $theme-color-gray;
        .ls-uppercase {
            font-size: 14px;
            font-weight: 500;
            color: $theme-color-black-light;
        }
    }
}

.themed-homegnome {
    .order-summary__mowing-description {
        border: 1px solid $theme-color-gray;
        .ls-uppercase {
            font-size: 14px;
            font-weight: 500;
            color: $theme-color-black-light;
        }
    }
}
</style>

<style lang="scss">
.affix {
    position: fixed;
}
</style>
